<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .advice
        .title--2
            text-align: left

    .cylinder-collection
        &__faq.section
            +media('<small')
                padding-top: $baseline
        &__filters
            margin-top: 4.125rem
        &__tabset
            margin-bottom: 4.125rem
            padding: 2.75rem 12.5%
        &__usage
            padding-top: $baseline*2
            margin-top: 25px
            +media('<medium')
                margin-top: 0
            .tabset
                padding-right: 8.333333%
                padding-left: 8.333333%
                +media('>=small')
                    padding-right: 13%
                    padding-left: 13%

                &__nav
                    margin-bottom: $baseline*.5
</style>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from 'swiper/modules';
import { reactive, ref, watch, onMounted, nextTick, provide } from 'vue';
import Locator from '../../common/components/locator/Locator.vue';
import Newsfeed from '../../common/components/Newsfeed.vue';
import Tabset from '../../common/components/tabset/Tabset.vue';
import Tab from '../../common/components/tabset/Tab.vue';

export default {
  components: {
    Locator,
    Newsfeed,
    Tabset,
    Tab,
    SwiperSlide,
    Swiper,
  },

  setup() {

    const filters = ref([])

    const products = reactive([])

    provide("registerProduct", (product) => {
      products.push(product);
    });

    watch(filters, (newFilters) => {
      products.forEach((product) => {
        product.toggleDisplay(newFilters);
      });
    });


    const toggleFilter = (filter) => {
      // Inclus mode
      filters.value = [filter];
    };

    onMounted(async () => {
      await nextTick()
      console.log("products == ", products)
    })

    return {
      filters,
      products,
      toggleFilter,

      modules: [Navigation]
    };
  }
};
</script>


